import { createActions } from "redux-actions";

/**
 * The constants here need to match the related actions. The actions
 * themselves are CONSTANT_CASED, but the related constants are camelCased
 * based on the _, so CONSTANT_CASED becomes constantCased, and something
 * like SOME_DUMB_THING is someDumbThing. Kinda dumb, but w/e.
 */
export const {
    applicationPatch,
    applicationPatchStart,
    applicationPatchError,
    applicationPatchSuccess,
    applicationPatchFinished,

    applicationRemove,
    applicationSetId,
    applicationSetState,
    applicationSetData,
    applicationSetExpireViewed,
    applicationSetComplete,
    applicationSetInternalApproved,
    applicationSkip,

    applicationModalShowHireApprove,
    applicationModalShowHirePass,
    applicationModalShowUpdateStep,

    hireRemove,
    hireSetData,
    hireSetHireDate,
    hireSetState,

    applicationsSetAll,
    applicationsMerge,
    hiresSetAll,
    hiresMerge,
} = createActions(
    "APPLICATION_PATCH",
    "APPLICATION_PATCH_START",
    "APPLICATION_PATCH_ERROR",
    "APPLICATION_PATCH_SUCCESS",
    "APPLICATION_PATCH_FINISHED",

    "APPLICATION_REMOVE",
    "APPLICATION_SET_ID",
    "APPLICATION_SET_STATE",
    "APPLICATION_SET_DATA",
    "APPLICATION_SET_EXPIRE_VIEWED",
    "APPLICATION_SET_COMPLETE",
    "APPLICATION_SET_INTERNAL_APPROVED",
    "APPLICATION_SKIP",

    "APPLICATION_MODAL_SHOW_HIRE_APPROVE",
    "APPLICATION_MODAL_SHOW_HIRE_PASS",
    "APPLICATION_MODAL_SHOW_UPDATE_STEP",

    "HIRE_REMOVE",
    "HIRE_SET_DATA",
    "HIRE_SET_HIRE_DATE",
    "HIRE_SET_STATE",

    "APPLICATIONS_SET_ALL",
    "APPLICATIONS_MERGE",
    "HIRES_SET_ALL",
    "HIRES_MERGE",
);
